<template>
	<div>
		<div v-if="loading">Loading.....</div>
		<div>Getting Order Report please wait....</div>
	</div>
</template>

<script>
import { useQuery, useResult } from '@vue/apollo-composable'
import { onMounted, reactive } from '@vue/composition-api'
import Store from '@/store'
import useProcessReportStore from '@/_srcv2/pages/_reports/create-report/useProcessReportStore.js'
import GetOrderReportDataQuery from './GetOrderReportDataQuery.graphql'

export default {
	name: 'GetOrderReportData',
	setup() {
		const {
			reportDocumentOurCompany,
			reportDocumentNumber,
			showGetData,
			showPdf,
			keyProcessReport,
		} = useProcessReportStore()
		// get order report info
		const options = reactive({
			fetchPolicy: 'no-cache',
		})
		const { result, refetch, loading } = useQuery(
			GetOrderReportDataQuery,
			() => ({
				company_id: reportDocumentOurCompany.value,
				order_number: reportDocumentNumber.value,
			}),
			options,
		)
		// ****************************************************************************************************
		const getReportData = (data) => {
			return new Promise((resolve, reject) => {
				if (data !== null || undefined) {
					const allReportDataForOrder = useResult(
						result,
						null,
						(data) => data.order_headers,
					)
					console.log('allReportDataForOrder', allReportDataForOrder)
					resolve(allReportDataForOrder.value[0])
				} else {
					const reason = new Error('Data could not be fetched from database')
					reject(reason)
				}
			})
		}
		const storeReportData = (data) => {
			return new Promise((resolve, reject) => {
				if (data !== null || undefined) {
					Store.dispatch('setPdfReportData', data).then(() => {
						if (Store.getters.getPdfReportData !== undefined) {
							console.log('')
							showGetData.value = false
							showPdf.value = true
							keyProcessReport.value += 1
							resolve(true)
						}
					})
				} else {
					const reason = new Error('Data can not be stored')
					reject(reason)
				}
			})
		}
		// ----------------------------------------------------------------------------
		const a = () => {
			getReportData(result).then((data) => {
				storeReportData(data)
			})
		}
		console.log('GetOrderReport created is fired')
		onMounted(() => {
			console.log('GetOrderReport onMounted is fired')
			refetch().then(() => a())
		})
		return {
			loading,
		}
	},
}
</script>

<style scoped>
.margin-top-25 {
	margin-top: 25px;
}
</style>
